
import { defineComponent, ref } from "vue";
import events, { ToastEvent } from "@/events";
import Toast from "@/components/toast/Toast.vue";

interface StoredToast {
    [key: number]: ToastEvent
}

export default defineComponent({
    components: { Toast },
    setup() {
        const toasts = ref<StoredToast>({});
        let id = 0;
        events.on('toast', toast => toasts.value[++id] = toast);

        function removeToast(id: number) {
            delete toasts.value[id];
        }

        return { toasts, removeToast };
    }

})
